import React, { Component } from 'react';
import * as Common from './../helpers/Common';
import * as Config from '../config/Config';
import * as User from '../helpers/User';
import Cwsubject from './Cwsubject';
const $ = window.$;

class Courseware extends Component {
	constructor(props) {
		super(props);
		this.state = {

			materials: [],
			material_title: '',
			subject_id: '',
			display: 'none',
			show: 'block',
			contentmsg:'Loading...',

		};

		this.getMatdetails = this.getMatdetails.bind(this);


	}


	getMatdetails(sub_id, tmp_id, sub, e) {


		var subject_id = sub_id + '_' + tmp_id + '_' + sub;

		//alert(subject_id);
		this.setState({
			show: 'none',
			display: 'block',
			subject_id: subject_id,

		});

	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			show: 'block',
			display: 'none',
		});
		Common.downTabClose();
	}




	getCourseMats() {

		Common.reactLoader("show", "Please wait...");
		let learnerID = Common.getUserData("id", true);
		//alert(learnerID);
		let productID = Common.getUserData("productID", true);
		//alert(productID);
		let corpID = Common.getUserData("corporateID", true);
		let pinID = Common.getUserData("pinID", true);

		// let learnerID = '25711';
		// let productID = '159';
		// let corpID = '34';
		// let pinID  = '468';
		fetch(Config.domainUrl + 'resources/course-mats', {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + Common.getTokenData()
			},

			body: JSON.stringify({
				learner_id: learnerID, corp_id: corpID, pinid: pinID, product: productID
			})
		}).then((response) => response.json())
			.then((responseJson) => {
				Common.reactLoader("hide");
				//alert(JSON.stringify(responseJson));
				if (responseJson.status != 0) {
					
					this.setState({
						materials: responseJson.materials,
						contentmsg:(responseJson.materials.length==0) ? " No Records Found." : " Loading...", 
						material_title: responseJson.material_title

					});
				}



			});
		Common.downTabClose();

	}


	componentDidMount() {
		this.getCourseMats();
		// $('#part2').hide();



	}




	render() {


		let contentmsgof=this.state.contentmsg;
		let materials = this.state.materials.map((material, i) => {

			return (


				<li key={`materials_${material.subject_id_pk}_${i}`} onClick={(e) => this.getMatdetails(material.subject_id_pk, material.template_id_fk, material.subject, e)} id={material.subject_id_pk} className='even' ><a href="javascript:void(0)" >{material.subject}</a></li>
			)
		});


		//(this.state.materials.length == 0) ? materials = ' No records found.' : materials = materials

		return (
			<div>
				<section id="contentsection" className="contentarea">
					<div id='part1' style={{ display: this.state.show }}>
						<div className="inner-title-bg journey-tit-bg"><h1><span><img src={process.env.PUBLIC_URL + "/images/img-courseware.jpg"} align="absmiddle" alt="" border="0" /></span>
							<span>{this.state.material_title}</span>
							<br /><span className="subtitle">MBA study material</span></h1></div>
						<div className="main-inner" id="courseware">
							<div className="border-box">
								<div className="title-box-gray title-box-blue">My Subjects</div>
								<section id="semana-scroll-inner" className="scroll">
									<section className="viewport">
										<section className="overview">
											<div className="inner-content">
												<ul className="sublist">
													{(materials.length > 0)?materials:contentmsgof}
												</ul>
											</div>
										</section>
									</section>
								</section>
							</div>
						</div>
					</div>
					<div id='part2' style={{ display: this.state.display }}>
						<Cwsubject subject_id={this.state.subject_id} materials={this.state.materials} />
					</div>
				</section>
			</div>
		);
	}
}

export default Courseware;




// WEBPACK FOOTER //
// ./src/learning_resources/Courseware.js